/**
 * Список ссылок для редиректа на новые категории
 */
export const UNIQUE_PATHS_OF_CATEGORY = {
  '/pizza/': '/category/pizza/',
  '/sety/': '/category/sety/',
  '/wok/': '/category/wok/',
  '/rolly/': '/category/rolly/',
  '/sushi/': '/category/rolly/',
  '/obed/': '/category/obed/',
  '/poke/': '/category/poke/',
  '/supy/': '/category/supy/',
  '/salaty/': '/category/salaty/',
  '/napitki/': '/category/napitki/',
  '/dessert/': '/category/dessert/',
  '/street/': '/category/street/',
  '/pirogi/': '/category/pirogi/',
  '/zakuski/': '/category/zakuski/',
  '/shashlyk/': '/category/shashlyk/',
  '/postnoe-menu/': '/category/postnoe-menu/',
  '/kidsmenu/': '/category/kidsmenu/',
  '/samovyvoz/': '/category/samovyvoz/',
  '/chernye_budni/': '/category/chernye_budni/',
  '/dobawky/': '/category/dobawky/',
  '/rolly-xxl/': '/category/rolly-xxl/',
  '/suveniryi/': '/category/suveniryi/',
}

/**
 * Наименование маршрута для [categories]/[product]
 */
export const CATEGORY_PRODUCT_PAGE_NAME = 'categories-product'
